import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { GetProtectedAreaOtherUseDetailsInputDto, ProtectedAreaOtherUseDetailCreateDto, ProtectedAreaOtherUseDetailDto, ProtectedAreaOtherUseDetailExcelDownloadDto, ProtectedAreaOtherUseDetailUpdateDto } from '../dtos/protected-area-other-use-detail/models';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';

@Injectable({
  providedIn: 'root',
})
export class ProtectedAreaOtherUseDetailService {
  private restService = inject(RestService);
  apiName = 'Geographic';
  

  create = (input: ProtectedAreaOtherUseDetailCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ProtectedAreaOtherUseDetailDto>({
      method: 'POST',
      url: '/api/geographic/protectedAreaOtherUseDetails',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/geographic/protectedAreaOtherUseDetails/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/geographic/protectedAreaOtherUseDetails',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ProtectedAreaOtherUseDetailDto>({
      method: 'GET',
      url: `/api/geographic/protectedAreaOtherUseDetails/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/geographic/protectedAreaOtherUseDetails/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetProtectedAreaOtherUseDetailsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<ProtectedAreaOtherUseDetailDto>>({
      method: 'GET',
      url: '/api/geographic/protectedAreaOtherUseDetails',
      params: { protectedAreaId: input.protectedAreaId, protectedAreaName: input.protectedAreaName, otherUseId: input.otherUseId, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: ProtectedAreaOtherUseDetailExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/geographic/protectedAreaOtherUseDetails/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, protectedAreaId: input.protectedAreaId, protectedAreaName: input.protectedAreaName, otherUseId: input.otherUseId, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ProtectedAreaOtherUseDetailDto[]>({
      method: 'GET',
      url: '/api/geographic/protectedAreaOtherUseDetails/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: ProtectedAreaOtherUseDetailUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ProtectedAreaOtherUseDetailDto>({
      method: 'PUT',
      url: `/api/geographic/protectedAreaOtherUseDetails/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}